import React from 'react';
import { Mail } from 'lucide-react';

interface SupportLinkProps {
  variant?: 'inline' | 'block' | 'block-with-icon';
  className?: string;
  showIcon?: boolean;
}

const SUPPORT_EMAIL = 'support@footypicks.co.uk';

export const SupportLink: React.FC<SupportLinkProps> = ({ 
  variant = 'inline',
  className = '',
  showIcon = false
}) => {
  if (variant === 'block' || variant === 'block-with-icon') {
    return (
      <div className={`text-center ${className}`}>
        <p className="text-sm text-gray-500 dark:text-gray-400">
          {variant === 'block-with-icon' && (
            <Mail className="inline-block h-4 w-4 mr-1.5 -mt-0.5" />
          )}
          Need help?{' '}
          <a 
            href={`mailto:${SUPPORT_EMAIL}`}
            className="text-theme-primary hover:text-theme-primary/80 hover:underline font-medium transition-colors"
          >
            {SUPPORT_EMAIL}
          </a>
        </p>
      </div>
    );
  }
  
  return (
    <a 
      href={`mailto:${SUPPORT_EMAIL}`}
      className={`text-theme-primary hover:text-theme-primary/80 hover:underline font-medium transition-colors ${className}`}
    >
      {showIcon && <Mail className="inline-block h-4 w-4 mr-1.5 -mt-0.5" />}
      {SUPPORT_EMAIL}
    </a>
  );
};
